module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_pen-4daed179ee202436867fe0a6084138f8.svg";